import { render } from "./FrontMenu.vue?vue&type=template&id=0826b38e"
import script from "./FrontMenu.vue?vue&type=script&lang=js"
export * from "./FrontMenu.vue?vue&type=script&lang=js"

import "./FrontMenu.vue?vue&type=style&index=0&id=0826b38e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__